exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reportTitle2 {\n  padding: 0 0.3rem 0.3rem 0.3rem;\n  width: 6.9rem;\n}\n.reportTitle2 .title {\n  font-size: 0.3rem;\n  font-weight: bold;\n  padding: 0.05rem 0.05rem 0rem 0.05rem;\n}\n.reportTitle2 .content {\n  width: 6.3rem;\n  margin: 0.1rem auto 0;\n  background-color: #FFF;\n  border-radius: 0.2rem;\n  padding: 0.3rem;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/app/roomsupport-op/ReportTitle2/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/app/roomsupport-op/ReportTitle2/index.less
// module chunks = 0